import { changeLocale } from "@/lang";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";
import vuetify from "@/plugins/vuetify";
import moment from "moment";
import { MutationTree } from "vuex";
import { AuthenticationState } from "./state";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_AZURE_DISPLAY_NAME = "SET_AZURE_DISPLAY_NAME";

export default {
    [SET_CURRENT_USER](state: AuthenticationState, value: ClientUser) {
        state.currentUser = value;
        vuetify.framework.theme.dark = value.userConfig.theme == "dark";
        if (value.userConfig.language) {
            state.locale = value.userConfig.language;
            moment.locale(value.userConfig.language);
            changeLocale(value.userConfig.language);
            LocalStorageManager.Write(LocalStorageRequests.LocaleLanguage, value.userConfig.language);
        }
    },
    [SET_AZURE_DISPLAY_NAME](state: AuthenticationState, value: string) {
        state.azureDisplayName = value;
    },
} as MutationTree<AuthenticationState>;
